import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import styles from "./EntityLabel.module.css";

export const EntityLabel = React.forwardRef(({ children, className, ...rest }, ref) => {
  return (
    <div
      ref={ref}
      className={classnames(styles.item_label, className)}
      {...rest}
    >
      {children}
    </div>
  );
});

EntityLabel.displayName = "EntityLabel";

EntityLabel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
